var _rect, _rect2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCrossDeleteIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    rx: 8,
    fill: "#DF252A",
    fillOpacity: 0.1
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4101_4539",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 2,
    width: 12,
    height: 12
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 12,
    height: 12,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4101_4539)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.20074 11.3267L4.67383 10.7998L7.47383 7.99976L4.67383 5.19976L5.20074 4.67285L8.00074 7.47285L10.8007 4.67285L11.3277 5.19976L8.52765 7.99976L11.3277 10.7998L10.8007 11.3267L8.00074 8.52668L5.20074 11.3267Z",
    fill: "#DF252A"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossDeleteIcon);
export default __webpack_public_path__ + "static/media/CrossDeleteIcon.be5844c132edd4911a1fbc85a3149f58.svg";
export { ForwardRef as ReactComponent };